import { render, staticRenderFns } from "./bars-graph.vue?vue&type=template&id=9fef267c&scoped=true&"
import script from "./bars-graph.vue?vue&type=script&lang=js&"
export * from "./bars-graph.vue?vue&type=script&lang=js&"
import style0 from "./bars-graph.vue?vue&type=style&index=0&id=9fef267c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fef267c",
  null
  
)

export default component.exports